<template>
  <v-popover
    class="NewActorButton mt-6"
    :class="[color, disableClass]"
    :disabled="!disable"
    offset="8"
  >
    <button
      class="NewActorButton-button flex items-center mr-8"
      @click="openNewActorModal"
    >
      <svg
        class="Icon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="8" cy="8" r="8" fill="black" />
        <line x1="8" y1="4" x2="8" y2="12" stroke="white" stroke-width="2" />
        <line x1="4" y1="8" x2="12" y2="8" stroke="white" stroke-width="2" />
      </svg>
      <span
        v-show="!disable"
        class="ml-3 whitespace-nowrap text-xxs text-gray-700 uppercase"
        >New actor</span
      >
    </button>
    <p slot="popover" class="mb-0">{{ helpMsg }}</p>
  </v-popover>
</template>

<script>
import {mapGetters} from 'vuex'
import {Modal, HelpMessages} from '@/lib/definitions'

export default {
  name: 'NewActorButton',
  components: {},
  props: {
    root: {
      type: Boolean,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    levelDepth: {
      type: Number,
      required: true
    },
    levelWidth: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      helpMsg: HelpMessages.ACTOR_LIMIT_EXCEEDED
    }
  },
  computed: {
    ...mapGetters(['rootActorLimit']),
    disable() {
      return this.root ? this.levelWidth >= this.rootActorLimit : false
    },
    disableClass() {
      return this.disable ? 'is-disabled' : false
    }
  },
  methods: {
    openNewActorModal() {
      if (!this.disable) {
        this.$router.pushQuery({modal: Modal.NEW_ACTOR})
      }
    }
  }
}
</script>

<style scoped>
.NewActorButton {
  &.is-disabled {
    .Icon circle {
      fill: theme('colors.gray.500');
    }
  }
  &:hover:not(.is-disabled) {
    .Icon circle {
      fill: currentColor;
    }
    span {
      color: inherit;
    }
  }
}
</style>
<style>
.js-focus-visible .NewActorButton-button:focus:not(.focus-visible) {
  outline: none;
}
</style>
